import { Box } from '@mui/material'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded'
import sxs from './_sxs'
import { FormFieldStatusesProps } from './_props'

export const statusesProps: FormFieldStatusesProps = {
    IDLE: {
        icon: <Box sx={sxs.FormFieldLabelIcon} />,
    },
    ERROR: {
        classes: {
            input: sxs.FormFieldError,
            label: sxs.FormFieldLabelError,
        },
        icon: <CancelRoundedIcon sx={[sxs.FormFieldLabelIcon, sxs.FormFieldLabelError]} />,
    },
    VALID: {
        classes: {
            label: sxs.FormFieldLabelValid,
        },
        icon: <CheckCircleRoundedIcon sx={[sxs.FormFieldLabelIcon, sxs.FormFieldLabelValid]} />,
    },
    WARNING: {
        classes: {
            input: sxs.FormFieldWarning,
            label: sxs.FormFieldLabelWarning,
            helperText: sxs.FormFieldHelperTextWarning,
        },
        icon: <ReportProblemRoundedIcon sx={[sxs.FormFieldLabelIcon, sxs.FormFieldLabelWarning]} />,
    },
}
